/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Brand_HeadingInputs */

const es_footer_brand_heading = /** @type {(inputs: Footer_Brand_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar`)
};

const gl_footer_brand_heading = /** @type {(inputs: Footer_Brand_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar`)
};

const en_footer_brand_heading = /** @type {(inputs: Footer_Brand_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar`)
};

/**
* | output |
* | --- |
* | "Zarpar" |
*
* @param {Footer_Brand_HeadingInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_brand_heading = /** @type {((inputs?: Footer_Brand_HeadingInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Brand_HeadingInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_brand_heading(inputs)
	if (locale === "en") return en_footer_brand_heading(inputs)
	return es_footer_brand_heading(inputs)
});